import { config } from '@things-factory/env'
import { getRoutePrefixForDomainType } from '@things-factory/shell'
import { getHeadlessPool as getHeadlessPoolForBoard } from './controllers/headless-pool-for-board.js'
import { getHeadlessPool as getHeadlessPoolForLabel } from './controllers/headless-pool-for-label.js'
import { internalBoardViewRouter } from './routers/internal-board-view-router.js'
import { standaloneBoardServiceRouter } from './routers/standalone-board-service-router.js'

const isPathBaseDomain = !config.get('subdomain')

process.on('bootstrap-module-global-public-route' as any, (app, domainGlobalPublicRouter) => {
  getHeadlessPoolForLabel()
  getHeadlessPoolForBoard()
  domainGlobalPublicRouter.use('', internalBoardViewRouter.routes(), internalBoardViewRouter.allowedMethods())
})

process.on('bootstrap-module-domain-private-route' as any, (app, domainPrivateRouter) => {
  if (isPathBaseDomain) {
    domainPrivateRouter.use(
      `/${getRoutePrefixForDomainType()}/:domain`,
      standaloneBoardServiceRouter.routes(),
      standaloneBoardServiceRouter.allowedMethods()
    )
  } else {
    domainPrivateRouter.use('', standaloneBoardServiceRouter.routes(), standaloneBoardServiceRouter.allowedMethods())
  }
})
